<div *ngIf="isReady()"></div>
<div>
  <div *ngIf="question" class="leftFloat clearBoth">{{getQuestionLabel()}}</div>
  <div class="leftFloat clearBoth fullWidth" #chartContainer></div>
</div>
